import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M20.5 1v6.5H19l-.621-2.485a2 2 0 0 0-1.94-1.515H9.5V11h3.806a2 2 0 0 0 1.973-1.671L15.5 8H17v7.5h-1.5l-.178-.892A2 2 0 0 0 13.36 13H9.5v6.5a1 1 0 0 0 1 1h6.146a3 3 0 0 0 2.683-1.658L20.5 16.5H22L21 23H2v-2l2.164-.36A1 1 0 0 0 5 19.652V4.347a1 1 0 0 0-.836-.986L2 3V1z"
    }, null, -1)
  ]));
}
const brandEcommerceEtsy = { render };
export {
  brandEcommerceEtsy as default,
  render
};
//# sourceMappingURL=brand-ecommerce-etsy.svg.js.map
